import { createApi } from '@reduxjs/toolkit/query/react';
import { aiBaseQuery } from '../core';

export const AIServiceApi = createApi({
  reducerPath: 'ai-service-api',
  baseQuery: aiBaseQuery,
  endpoints: (builder) => ({
    aiVersionTest: builder.query<
      {
        status: string;
        message: string;
        data: {
          message: string;
          version_info: {
            commit_id: string;
            build_date: string;
            version: string;
          };
          note: string;
        };
      },
      void
    >({
      query: () => ({
        url: 'version-test',
      }),
    }),
  }),
});

export const { useAiVersionTestQuery } = AIServiceApi;
